class Cupom extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {
    this.insertAdjacentHTML('beforeend', `<svg class="coupon-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>`);
    this.addEventListener("click", this.handleCopyCoupon.bind(this));
  }

  handleCopyCoupon() {
    const coupon = this.textContent.trim();
    const temp_text = "Copiado";

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(coupon);

      return this.changeInnerTextTemporarily(temp_text, 1000);
    }

    // Fallback para navegadores antigos
    let textarea = document.createElement("textarea");
    textarea.value = texto;
    textarea.style.position = "fixed"; // Evita rolagem da página

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      let sucesso = document.execCommand("copy");
      console.log(sucesso ? "Texto copiado com sucesso!" : "Falha ao copiar.");
    } catch (err) {
      console.error("Erro ao copiar: ", err);
    }

    document.body.removeChild(textarea);
  }

  changeInnerTextTemporarily(text, time) {
    const originalText = this.textContent;
    this.textContent = text;
    this.insertAdjacentHTML('beforeend', `<svg class="coupon-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>`);
    this.classList.add("copied");

    setTimeout(() => {
      this.textContent = originalText;
      this.insertAdjacentHTML('beforeend', `<svg class="coupon-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>`);
      this.classList.remove("copied");
    }, time);
  }
}

customElements.define("copy-coupon", Cupom);
